(function () {
  "use strict";

  /* ─────────────────────────────────────────────
     INJECT STYLES
  ───────────────────────────────────────────── */
  var css = "";

  /* ── Product card heart button — transparent, no theme bg ── */
  css += ".wishlist-productcard {";
  css += "  position: absolute; top: 8px; right: 8px; z-index: 5;";
  css += "  background: none !important; border: none !important;";
  css += "  box-shadow: none !important; border-radius: 0;";
  css += "  width: 32px; height: 32px; min-width: 0 !important; min-height: 0 !important;";
  css += "  padding: 0 !important; margin: 0 !important; float: none !important;";
  css +=
    "  display: flex !important; align-items: center; justify-content: center;";
  css += "  cursor: pointer;";
  css += "  transition: transform 0.2s;";
  css += "}";
  css += ".wishlist-productcard:before, .wishlist-productcard:after {";
  css += "  display: none !important; content: none !important;";
  css += "}";
  css +=
    ".wishlist-productcard:hover { background: none !important; transform: scale(1.15); }";
  css +=
    ".wishlist-productcard i { font-size: 18px; color: #ffffff; transition: color 0.2s; }";
  css += ".wishlist-productcard:hover i { color: #e53935; }";
  css += ".wishlist-productcard.gf-wishlisted i { color: #e53935; }";

  /* ── Product page heart button — same height as ATC, 10px gap, proper border ── */
  css +=
    ".submit.m10.custom-add-to-cart-css { display: flex !important; align-items: stretch !important; gap: 10px !important; width: 100% !important; }";
  css +=
    ".submit.m10.custom-add-to-cart-css > .f8pr-button.wide { flex: 1 !important; min-width: 0 !important; margin-right: 0 !important; }";
  css +=
    ".wishlist-productpage { display: flex !important; flex-shrink: 0; margin: 0 !important; }";
  css += ".wishlist-productpage a {";
  css += "  display: flex; align-items: center; justify-content: center;";
  css += "  width: 50px; min-height: 46px;";
  css += "  border: 1.5px solid var(--custom_bd, #ddd);";
  css += "  border-radius: var(--b2r, 4px);";
  css += "  background: var(--primary_bg, #fff);";
  css += "  text-decoration: none; cursor: pointer;";
  css += "  transition: background 0.2s, border-color 0.2s;";
  css += "}";
  css +=
    ".wishlist-productpage a:hover { background: rgba(229,57,53,0.06); border-color: #e53935; }";
  css +=
    ".wishlist-productpage a i { font-size: 20px; color: var(--primary_text); transition: color 0.2s; line-height: 1; }";
  css += ".wishlist-productpage a.gf-wishlisted i { color: #e53935; }";

  /* ── Header badge ── */
  css += ".wishlist-header { position: relative; }";
  css += ".gf-wishlist-count {";
  css += "  position: absolute; top: 9px !important; right: -6px !important;";
  css += "  background: var(--secondary_bg, #F4602B); color: #fff;";
  css += "  border-radius: 50%; font-size: 10px; font-weight: 700;";
  css += "  min-width: 16px; width: 16px; height: 16px;";
  css += "  display: none; align-items: center; justify-content: center;";
  css += "  line-height: 1; pointer-events: none;";
  css += "}";

  /* ── Heart pop animation ── */
  css +=
    "@keyframes gf-wish-pop { 0%{transform:scale(1)} 40%{transform:scale(1.35)} 100%{transform:scale(1)} }";
  css += ".gf-wish-pop { animation: gf-wish-pop 0.3s ease; }";

  /* ══════════════════════════════════════════════
     WISHLIST PAGE
  ══════════════════════════════════════════════ */

  /* ── Page container — width handled by #content parent ── */
  css += ".gf-wishlist-page { padding: 0 0 60px; }";
  css +=
    ".gf-wishlist-page > header { padding: 20px 0 20px; margin-bottom: 24px; }";
  css += ".gf-wishlist-page > header h1 { margin: 0; }";
  css +=
    ".gf-wishlist-header-count { font-size: 0.65em; opacity: 0.5; font-weight: 400; margin-left: 4px; }";

  /* ── Empty state ── */
  css += ".gf-wishlist-empty { text-align: center; padding: 80px 20px; }";
  css +=
    ".gf-wishlist-empty i { font-size: 64px; color: var(--custom_bd, #ddd); display: block; margin-bottom: 20px; }";
  css += ".gf-wishlist-empty h2 { margin: 0 0 8px; }";
  css += ".gf-wishlist-empty p { color: #888; }";
  css +=
    ".gf-wishlist-empty a { display: inline-flex; align-items: center; gap: 6px; }";

  /* ── Wishlist card — consistent height ── */
  css +=
    ".gf-wishlist-grid .product-card > div { display: flex; flex-direction: column; }";
  css += ".gf-wishlist-grid .product-card .custom-product-title-css {";
  css +=
    "  display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;";
  css += "font-family: 'Lato', sans-serif !important; line-height: 1.4;";
  css += "}";

  /* ── Wishlist card buttons — above theme link overlay ── */
  css +=
    ".gf-wl-btns { display: flex; gap: 6px; margin-top: auto; padding-top: 10px; position: relative; z-index: 10; }";
  css += ".gf-wl-btns > button {";
  css +=
    "  flex: 1 1 0% !important; width: 50% !important; min-width: 0 !important; max-width: none !important; height: 34px;";
  css +=
    "  display: flex !important; align-items: center; justify-content: center;";
  css += "  border-radius: var(--b2r, 4px); cursor: pointer;";
  css += "  font-family: inherit; font-size: 12px; line-height: 1;";
  css +=
    "  text-decoration: none !important; white-space: nowrap; padding: 0 6px;";
  css += "  transition: opacity 0.2s; box-sizing: border-box;";
  css += "}";
  css +=
    "button.gf-wl-atc { background: #1A4D2E !important; color: #fff !important; border: none; }";
  css += "button.gf-wl-atc:before { background: #1A4D2E !important; }";
  css += "button.gf-wl-atc:hover { opacity: 0.9; }";
  css += ".gf-wl-rm {";
  css += "  background: none; border: 1.5px solid var(--custom_bd, #ddd);";
  css += "  color: var(--primary_text); gap: 4px;";
  css += "}";
  css += ".gf-wl-rm:hover { border-color: #e53935; color: #e53935; }";
  css += ".gf-wl-rm i { font-size: 12px; }";

  /* ── Responsive — mobile buttons ── */
  css += "@media (max-width: 768px) {";
  css += "  .gf-wishlist-page > header { padding: 0; margin-bottom: 16px; }";
  css += "  .gf-wishlist-page { padding: 0 0 0px; }";
  css +=
    "  .gf-wishlist-page .product-card { margin-bottom: 16px !important; }";
  css +=
    "  .gf-wishlist-page .product-card h3 { margin-bottom: 0 !important; }";
  css += "  .gf-wishlist-page .product-card button { margin: 0 !important; }";
  css += "  .gf-wishlist-page .product-card figure { margin-bottom: 8px !important; }";
  css +=
    "  .gf-wl-btns > * { height: 28px; min-height: 28px !important; font-size: 11px; }";
  css += "}";

  var styleEl = document.createElement("style");
  styleEl.textContent = css;
  document.head.appendChild(styleEl);

  /* ─────────────────────────────────────────────
     STORAGE HELPERS
  ───────────────────────────────────────────── */
  var STORAGE_KEY = "gf_wishlist";

  function getItems() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveItems(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {}
  }

  function hasItem(id) {
    return getItems().some(function (p) {
      return String(p.id) === String(id);
    });
  }

  function addItem(data) {
    var items = getItems();
    if (!hasItem(data.id)) {
      items.push(data);
      saveItems(items);
    }
  }

  function removeItem(id) {
    saveItems(
      getItems().filter(function (p) {
        return String(p.id) !== String(id);
      }),
    );
  }

  function getCount() {
    return getItems().length;
  }

  /* ─────────────────────────────────────────────
     PRICE FORMATTER
  ───────────────────────────────────────────── */
  function formatMoney(cents) {
    if (!cents || isNaN(cents)) return "";
    var amount = parseInt(cents, 10) / 100;
    return "\u20B9" + Math.round(amount).toLocaleString("en-IN");
  }

  /* ─────────────────────────────────────────────
     UI HELPERS
  ───────────────────────────────────────────── */
  function setActive(el, active) {
    if (!el) return;
    var icon = el.querySelector("i");
    if (active) {
      el.classList.add("gf-wishlisted");
      if (icon) {
        icon.className = "icon-heart";
        icon.style.color = "#e53935";
      }
      el.setAttribute("aria-label", "Remove from Wishlist");
    } else {
      el.classList.remove("gf-wishlisted");
      if (icon) {
        icon.className = "icon-heart-outline";
        icon.style.color = "";
      }
      el.setAttribute("aria-label", "Add to Wishlist");
    }
  }

  function updateBadge() {
    var count = getCount();
    document.querySelectorAll(".gf-wishlist-count").forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? "flex" : "none";
    });
  }

  /* ─────────────────────────────────────────────
     TOGGLE ITEM
  ───────────────────────────────────────────── */
  function toggle(btn) {
    var id = btn.dataset.productId;
    if (!id) return;

    if (hasItem(id)) {
      removeItem(id);
      setActive(btn, false);
    } else {
      addItem({
        id: id,
        handle: btn.dataset.productHandle || "",
        title: btn.dataset.productTitle || "",
        price: btn.dataset.productPrice || "0",
        compare_at_price: btn.dataset.productComparePrice || "0",
        image: btn.dataset.productImage || "",
        url: btn.dataset.productUrl || "",
        variant_id: btn.dataset.variantId || "",
        is_personalized: btn.dataset.isPersonalized === "true",
      });
      setActive(btn, true);
      btn.classList.add("gf-wish-pop");
      btn.addEventListener(
        "animationend",
        function () {
          btn.classList.remove("gf-wish-pop");
        },
        { once: true },
      );
    }

    updateBadge();
    syncAllButtons(id);
    if (document.querySelector(".gf-wishlist-page")) renderPage();
  }

  function syncAllButtons(id) {
    var active = hasItem(id);
    document
      .querySelectorAll(
        '.wishlist-productcard[data-product-id="' +
          id +
          '"], .wishlist-productpage a[data-product-id="' +
          id +
          '"]',
      )
      .forEach(function (btn) {
        setActive(btn, active);
      });
  }

  /* ─────────────────────────────────────────────
     INIT PAGE BUTTONS
  ───────────────────────────────────────────── */
  function initButtons() {
    document
      .querySelectorAll(".wishlist-productcard:not([data-wl-init])")
      .forEach(function (btn) {
        btn.dataset.wlInit = "1";
        setActive(btn, hasItem(btn.dataset.productId));
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          toggle(this);
        });
      });

    document
      .querySelectorAll(".wishlist-productpage a:not([data-wl-init])")
      .forEach(function (link) {
        link.dataset.wlInit = "1";
        setActive(link, hasItem(link.dataset.productId));
        link.addEventListener("click", function (e) {
          e.preventDefault();
          toggle(this);
        });
      });
  }

  /* ─────────────────────────────────────────────
     HTML ESCAPE
  ───────────────────────────────────────────── */
  function esc(str) {
    return String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  /* ─────────────────────────────────────────────
     AUTO-FETCH MISSING IMAGES
  ───────────────────────────────────────────── */
  function refreshProductData(cb) {
    var items = getItems();
    var needFetch = items.filter(function (p) {
      return !p.image && p.handle;
    });
    if (needFetch.length === 0) {
      if (cb) cb();
      return;
    }
    var done = 0;
    needFetch.forEach(function (p) {
      fetch("/products/" + p.handle + ".js")
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          if (data.featured_image) p.image = data.featured_image;
        })
        .catch(function () {})
        .finally(function () {
          done++;
          if (done === needFetch.length) {
            saveItems(items);
            if (cb) cb();
          }
        });
    });
  }

  /* ─────────────────────────────────────────────
     RENDER WISHLIST PAGE
  ───────────────────────────────────────────── */
  function renderPage() {
    var container = document.querySelector(".gf-wishlist-grid");
    var emptyEl = document.querySelector(".gf-wishlist-empty");
    var countEl = document.querySelector(".gf-wishlist-header-count");
    if (!container) return;

    var items = getItems();
    if (countEl)
      countEl.textContent = items.length > 0 ? "(" + items.length + ")" : "";

    if (items.length === 0) {
      container.innerHTML = "";
      if (emptyEl) emptyEl.style.display = "";
      return;
    }
    if (emptyEl) emptyEl.style.display = "none";

    container.innerHTML = items
      .map(function (p) {
        var hasCompare =
          p.compare_at_price &&
          parseInt(p.compare_at_price, 10) > parseInt(p.price, 10);
        var imgHtml = p.image
          ? '<picture><img src="' +
            esc(p.image) +
            '" alt="' +
            esc(p.title) +
            '" loading="lazy"></picture>'
          : '<picture><svg class="placeholder-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525 525"><path d="M263 65c109 0 198 89 198 198S372 461 263 461 65 372 65 263 154 65 263 65z" fill="none" stroke="#ddd" stroke-width="2"/></svg></picture>';

        return (
          '<li class="product-card" data-pid="' +
          p.id +
          '">' +
          "<figure>" +
          '<a href="' +
          esc(p.url) +
          '" aria-label="' +
          esc(p.title) +
          '">' +
          imgHtml +
          "</a>" +
          "</figure>" +
          "<div>" +
          '<h3 class="p0 custom-product-title-css"><a href="' +
          esc(p.url) +
          '">' +
          esc(p.title) +
          "</a></h3>" +
          '<p class="price s1pr">' +
          (hasCompare
            ? '<span class="old-price">' +
              formatMoney(p.compare_at_price) +
              "</span>&nbsp;"
            : "") +
          formatMoney(p.price) +
          "</p>" +
          '<div class="gf-wl-btns">' +
          // '<button type="button" class="gf-wl-atc" data-url="' +
          // esc(p.url) +
          // '">Add to Cart</button>' +
          '<button type="button" class="gf-wl-rm" data-rid="' +
          p.id +
          '">Remove</button>' +
          "</div>" +
          "</div>" +
          "</li>"
        );
      })
      .join("");

    /* Attach ATC redirect */
    container.querySelectorAll(".gf-wl-atc[data-url]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = this.dataset.url;
      });
    });

    /* Attach Remove events */
    container.querySelectorAll(".gf-wl-rm[data-rid]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var id = this.dataset.rid;
        removeItem(id);
        updateBadge();
        syncAllButtons(id);
        renderPage();
      });
    });
  }

  /* ─────────────────────────────────────────────
     INIT
  ───────────────────────────────────────────── */
  function init() {
    updateBadge();
    initButtons();
    if (document.querySelector(".gf-wishlist-page")) {
      refreshProductData(function () {
        renderPage();
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("wishlist:reinit", initButtons);
  document.addEventListener("quickshop:opened", function () {
    setTimeout(initButtons, 150);
  });

  /* ── Watch for dynamically loaded sections (recommendations, quickshop drawer, etc.) ──
     PERF: Scoped to specific AJAX/dynamic containers only — NOT document.body.
     Watching body with subtree:true fires on every scroll/animation/drawer
     interaction, which caused huge TBT regressions. These targets cover every
     place wishlist buttons get injected after page load:
       - .m6pn        → theme's shared drawer class (cart, quickshop, etc.)
       - product/recently-viewed rec sections
       - #section-related
       - .gf-wishlist-page (in-page wishlist rendering) */
  var WL_NEW_SELECTOR =
    ".wishlist-productcard:not([data-wl-init]), .wishlist-productpage a:not([data-wl-init])";
  var WL_OBSERVE_TARGETS = [
    ".m6pn",
    ".product-recommendations",
    ".recently-viewed-products",
    "#section-related",
    ".gf-wishlist-page"
  ];
  var observer = new MutationObserver(function (mutations) {
    for (var mi = 0; mi < mutations.length; mi++) {
      var addedNodes = mutations[mi].addedNodes;
      for (var ni = 0; ni < addedNodes.length; ni++) {
        var node = addedNodes[ni];
        if (node.nodeType !== 1) continue;
        if (
          (node.matches && node.matches(WL_NEW_SELECTOR)) ||
          (node.querySelector && node.querySelector(WL_NEW_SELECTOR))
        ) {
          initButtons();
          return; // one init call per batch
        }
      }
    }
  });
  WL_OBSERVE_TARGETS.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (root) {
      observer.observe(root, { childList: true, subtree: true });
    });
  });
})();